/*
 * @Author: Json Chen
 * @Date: 2021-06-29 10:17:31
 * @LastEditTime: 2021-06-29 10:20:35
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Product/Components/ProductAttributeDropdownOptions.tsx
 */
import React from 'react';
import { Form } from 'antd';
import {
  // 移动手柄
  PlusOutlined,
} from '@ant-design/icons';
import styles from '../style.module.less';
import ProductAttributeModalOptions from './ProductAttributeModalOptions';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const DropdownOptions = ({
  defaultOptions,
  inputKey,
  setConfirmDisable,
  addOption,
}: any) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  return (
    <>
      <Form.Item
        name={'options'}
        className={styles.options}
        label={
          <div className={styles.optionLabel}>
            <div className={styles.title}>
              {defaultOptions
                ? getI18n('storeProductSetting.detail.otherAttributeOptions')
                : getI18n('storeProductSetting.detail.attributeOptions')}
            </div>
            <div className={styles.describe}>
              {getI18n('storeProductSetting.detail.optionTip')}
            </div>
          </div>
        }>
        <ProductAttributeModalOptions
          defaultOptions={defaultOptions}
          inputKey={inputKey}
          setConfirmDisable={setConfirmDisable}
        />
      </Form.Item>
      <span className={styles.addButton} onClick={addOption}>
        <i>
          <PlusOutlined />
        </i>
        <span>{getI18n('storeProductSetting.detail.addoption')}</span>
      </span>
    </>
  );
};

export default DropdownOptions;
